export default {"src":"/_next/static/media/spinner-example.cadd80ee.gif","height":341,"width":833,"blurWidth":0,"blurHeight":0};